/* eslint-disable */
import select2 from "select2";
import 'select2/dist/css/select2.min.css';
/* eslint-enable */
const selectWithFlag = (select, additionText = 'From') => {
  if (!select) return;
  if(themeVars.currentLang == 'en') {
    select.val('United States');
  }
  select.select2({
    templateResult: function (idioma) {
      let countryCurrent = idioma.text,
        country = countryCurrent.replace(/\s/g, "_"),
        span = '';
      if (country !== 'Searching…') {
        span = $("<span><img width='33px' height='24px' src='"+themeVars.flagsUrl + country + ".png' alt='" + idioma.text + "'/> " + idioma.text + "</span>");
        return span;
      }
    },
    templateSelection: function (idioma) {
      let countryCurrent = idioma.text,
        country = countryCurrent.replace(/\s/g, "_"),
        span = '';
      if (country !== 'Searching…') {
        span = $("<span><img width='33px' height='24px' src='"+themeVars.flagsUrl + country + ".png' alt='" + idioma.text + "'/> " + additionText + ' ' + idioma.text + "</span>");
        return span;
      }
    },
  });
}

export default selectWithFlag;
